var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { loanResponseStatus } from '@repo/shared/types';
import { baseCommon, documentsCommon, limitCommon, loanCommon, valueCommon, } from './steps-common-data.mock';
export var loanProcessStep3 = __assign(__assign({}, baseCommon), { data: {
        preLimitId: 1,
        loan: loanCommon,
        limit: limitCommon,
        documents: documentsCommon,
        value: valueCommon,
        status: loanResponseStatus.enum.OPEN,
        stage: 3,
    } });
